import { NavLink, useNavigate } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';

const RelationshipTabs = ({ contactId, activeKey, onTabClick = () => {}, className = '' }) => {
  const navigate = useNavigate();

  const tabs = [
    { key: 'overview', label: 'Overview', to: `/relationship/${contactId}` },
    { key: 'interactions', label: 'Interactions', to: `/relationship/${contactId}/interaction` },
    { key: 'interests', label: 'Interests', to: `/relationship/${contactId}/interests` },
    { key: 'family', label: 'Family', to: `/relationship/${contactId}/family` },
    { key: 'employment', label: 'Employment', to: `/relationship/${contactId}/employment` },
  ];

  return (
    <div className={`flex flex-wrap items-center justify-center gap-4 text-sm font-semibold text-slate-200 ${className}`}>
      <button
        type="button"
        onClick={() => navigate('/relationships')}
        className="inline-flex items-center text-slate-200 hover:text-slate-50"
        aria-label="Back to relationships"
      >
        <LuArrowLeft className="h-6 w-6" />
      </button>
      <div className="flex flex-1 flex-wrap items-center justify-center gap-4">
        {tabs.map((tab) => (
          <NavLink
            key={tab.key}
            to={tab.to}
            className={({ isActive }) =>
              `pb-1 transition hover:text-slate-50 ${
                isActive || activeKey === tab.key ? 'text-slate-50 underline underline-offset-4' : ''
              }`
            }
            end={tab.key === 'overview'}
            onClick={() => onTabClick(tab.key)}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className="w-6" />
    </div>
  );
};

export default RelationshipTabs;
